import React, { useEffect, useState } from 'react'
import { Row, Col, CheckboxGroup, Checkbox } from 'rsuite'
import { requiredFiled, isValidators } from '../../../utils/ValidatorUtils'
import CustomIconMessageInfo from '../../../widgets/CustomIconMessageInfo'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'

export default function InputCheckboxForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  index,
  onChange = () => {},
  ...props
}) {
  const keyName = props?.name || schema?.name
  const labelMdLg = props.labelMdLg || 24
  const inputMdlg = props.inputMdlg || 24
  const disabled = props.disabled || false
  const inline = props.inline || schema?.inline

  const [inputValue, setInputValue] = useState(props.value || schema?.value || [])

  useEffect(() => {
    setInputValue(props.value || schema?.value || [])
  }, [props.value, schema])

  return (
    <>
      {schema && (
        <Row style={{ ...props.style }}>
          {errors[keyName] && (
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
              <ErrorMessage error={errors[keyName]} />
            </Col>
          )}

          {!props.hideLabel && schema.label && (
            <Col xs={24} sm={24} md={labelMdLg} lg={labelMdLg} style={{ marginTop: 10 }}>
              <p style={{ fontWeight: schema.isBolder ? 'bolder' : undefined }}>
                {requiredFiled(schema.validators, `${schema.label} ${index || ''}`)}
              </p>
            </Col>
          )}
          {schema.description && (
            <Col xs={24} sm={24} md={labelMdLg} lg={labelMdLg} style={{ marginTop: 10 }}>
              <CustomIconMessageInfo style={{ marginBottom: 10 }} contents={schema.description} />
            </Col>
          )}
          <Col xs={24} sm={24} md={inputMdlg} lg={inputMdlg} style={{ marginTop: 5 }}>
            <Controller
              key={keyName}
              name={keyName}
              control={control}
              rules={isValidators(schema.validators)}
              defaultValue={inputValue}
              render={(props) => {
                return (
                  <CheckboxGroup
                    inline={inline}
                    name={'ck_' + keyName}
                    value={inputValue}
                    onChange={(value) => {
                      props.onChange(value)
                      setInputValue(value)
                      onChange(value)
                    }}
                  >
                    {schema.options?.map((item) => {
                      return (
                        <Checkbox value={item.value} disabled={disabled || schema.disabled}>
                          {item.label}
                        </Checkbox>
                      )
                    })}
                  </CheckboxGroup>
                )
              }}
            />
          </Col>
        </Row>
      )}
    </>
  )
}
